import { CARE_LEVEL_LABELS } from '../../constants/careLevels';

// Цвет точки уровня ухода — как на сайте (light/medium/demanding)
const DOT_COLORS = {
  light: 'bg-[#6FA87C]',
  medium: 'bg-[#D3A24A]',
  demanding: 'bg-[#C4654B]',
};

// Плашка «Уход: …» в теле карточки и на странице товара —
// сплошной кремовый фон, тёмный текст: читается на любом фото
export default function CareBadge({ careLevel }) {
  if (!careLevel || !CARE_LEVEL_LABELS[careLevel]) return null;
  return (
    <span className="inline-flex items-center gap-1.5 self-start rounded-full bg-[#f3efe7] px-2.5 py-1 text-[11px] font-semibold leading-none text-green-dark ring-1 ring-border-warm">
      <span className={`h-2 w-2 shrink-0 rounded-full ${DOT_COLORS[careLevel] || 'bg-green-sage'}`} />
      Уход: {CARE_LEVEL_LABELS[careLevel]}
    </span>
  );
}
